import * as yup from 'yup';

export const womanType = yup.string().required('Påkrævet');
